import { SelectItem } from 'primeng/api';
import { YES, NO } from '@shared/constants';

export const Requestors = [
    'CareBridge',
    'HHA',
    'Member',
    'Member Representative',
    'MD',
    'SNF',
    'Hospital',
    'Health Plan Case Manager'
];

export const RequestorsDropdownMap = {
    Humana: [...Requestors, 'Cohere'],
    Aetna: [...Requestors],
    Anthem: [...Requestors],
    Regence: [...Requestors],
    BCBSRI: [...Requestors]
};

export enum RequestorsEnum {
    HHA = 'HHA',
    Member = 'Member',
    MemberRepresentative = 'Member Representative',
    MD = 'MD',
    SNF = 'SNF',
    Hospital = 'Hospital',
    HealthPlanCaseManager = 'Health Plan Case Manager'
}

export const YesNoOptions: SelectItem[] = [
    {
        label: YES,
        value: YES
    },
    {
        label: NO,
        value: NO
    }
];

export const YesNoBooleanOptions: SelectItem[] = [
    {
        label: YES,
        value: true
    },
    {
        label: NO,
        value: false
    }
];
